import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Heart } from "lucide-react";

export function SportyPeopleBadge({ className = "", dark = false, compact = false }) {
  const { branding } = useApp();
  const [open, setOpen] = useState(false);
  const compactCls = dark ? "text-white/70 hover:text-white" : "text-slate-400 hover:text-[#003284]";
  return (
    <>
      {compact ? (
        <button data-testid="sporty-badge" onClick={() => setOpen(true)} className={`inline-flex items-center gap-1.5 text-xs font-semibold transition-colors ${dark ? "text-white/80 hover:text-white" : "text-slate-600 hover:text-[#003284]"} ${className}`}>
          <span>by</span>
          {branding?.sporty_logo_url
            ? <img src={branding.sporty_logo_url} alt="Sporty People" className="h-6 w-auto" />
            : <span className="font-bold">Sporty People</span>}
          <span className="underline underline-offset-2">Quiénes somos</span>
        </button>
      ) : (
        <button data-testid="sporty-badge" onClick={() => setOpen(true)} className={`inline-flex items-center gap-2 text-sm font-bold transition-opacity hover:opacity-80 ${dark ? "text-white/80" : "text-slate-500"} ${className}`}>
          <span>by</span>
          {branding?.sporty_logo_url
            ? <img src={branding.sporty_logo_url} alt="Sporty People" className="h-6 w-auto" />
            : <span className={dark ? "text-[#FFB81C]" : "brand-navy"}>Sporty People</span>}
        </button>
      )}

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="sporty-dialog">
          <DialogHeader>
            <DialogTitle className="brand-navy text-2xl font-black flex items-center gap-2">
              <Heart size={20} className="text-[#F68D2E]" />
              {branding?.sporty_logo_url
                ? <img src={branding.sporty_logo_url} alt="Sporty People" className="h-10 w-auto" />
                : "Sporty People"}
            </DialogTitle>
          </DialogHeader>
          <p className="text-slate-600 leading-relaxed whitespace-pre-line">{branding?.sporty_about}</p>
        </DialogContent>
      </Dialog>
    </>
  );
}
